<script>
    import ImageTile from "./ImageTile.svelte";
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";
    import clickTracker from "../tracking/clickTracker.js";
    import DiscountTag from "./DiscountTag.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        recommendation,
        lazyLoad,
        additionalTrackingLabels = null,
        additionalCinemaClickTracking,
        cinemaMeta,
        cinemaTracking,
        featureIndex,
        cinemaIndex,
    } = $props();

    const { width: widthAmount, height: heightAmount } = getContext(cinemaTileDimensionCtxKey);
    const width = `${widthAmount}px`;
    const height = `${heightAmount}px`;

    const {
        image,
        _embedded: { "o:variation": variation },
        tracking,
    } = recommendation;

    const baseDetailViewUrl = variation._links["o:base-detail-view-url"]?.href;
    const variationDetailViewUrl = variation._links["o:variation-detail-view-url"]?.href;
    const discountValue = variation.discountValue;

    const clickHandler = () => {
        clickTracker(
            cinemaTracking,
            tracking,
            featureIndex,
            cinemaIndex,
            additionalCinemaClickTracking,
            recommendation.additionalClickTracking,
            cinemaMeta,
            recommendation.meta,
            additionalTrackingLabels
        );
    };

    const getDataTracking = () => {
        const promoSource = recommendation.tracking?.labels?.promo_Source;
        const promoTypeSuffix = recommendation.tracking?.name?.split("-")[0];

        if (!promoSource || !promoTypeSuffix) {
            return undefined;
        }

        return '{"promo_Source":"' + promoSource + '","promo_Type":"' + `promo_${promoTypeSuffix}` + '"}';
    };
</script>

<li
    style:min-width={width}
    style:max-width={width}
    style:height
    data-tracking={getDataTracking()}
    data-tracking-feature-id={tracking?.id}
    data-qa="slidingCinemaPromotion"
    class="reco_trend_cinema__tile"
>
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <oc-card-v2 onclick={clickHandler} data-testid="trend-card">
        <oc-link-v2 base64-href={btoa(variationDetailViewUrl)}>
            <a href={baseDetailViewUrl}>
                <ImageTile {image} {lazyLoad} />
            </a>
        </oc-link-v2>
    </oc-card-v2>
    <div class="reco_trend_cinema__discount_tag_wrapper">
        <DiscountTag {discountValue} />
    </div>
</li>

<style lang="scss">
    .reco_trend_cinema__tile {
        display: flex;
        flex-direction: column;
        margin: 0 8px 0 0;
        vertical-align: top;
        white-space: normal;
        position: relative;
        height: 100%;

        &:last-child {
            margin-right: 0;
        }
    }

    .reco_trend_cinema__discount_tag_wrapper {
        position: absolute;
        bottom: 16px;
        left: 16px;
    }
</style>
